import * as actionTypes from '../actions/ActionTypes'

export default function (state = [], action) {
  switch (action.type) {
    case actionTypes.CREDIT_UPDATE:
      return action.credit
    default:
      return state
  }
}